<template>
  <div class="place-order">
    <!-- 头部 -->
    <LifeTopbar :title="title" />

    <div class="unit">
    	<!-- 选择单位 -->
    	<LifeForm v-if="unitList[0].list.length > 1" :value.sync="unit" :list.sync="unitList"  />
    	<!-- 选择套餐 -->
    	<div v-if="packageSelect.length > 1" class="sub">
    		<div v-for="(item, index) in packageSelect" @click="tap(item)"
    		:class="{ active: packageAct.id === item.id }" class="item">
    			<div v-if="item.ptype == 5" class="price">
    				{{Number(item.amount) > 0 ? '₱':'$'}}{{Number(item.amount) > 0 ? item.amount: item.doller}}
    			</div>
    			<div class="name">
    				{{item.name}}
    			</div>
    		</div>
    	</div>
    </div>

    <!-- 通过套餐param得到的表单 -->
    <div v-if="formList.length > 0" class="place-order-form">
    	<LifeForm :value.sync="form" :list.sync="formList" @listChange="listChange"  />
    </div>

    <!-- 缴费金额 -->
    <div class="place-order-form">
    	<LifeForm :value.sync="priceForm" :list.sync="priceFormList" />
    </div>
    <!-- 手续费 -->
    <div v-if="packageAct.service_fee > 0 && packageAct.ptype != 5" class="place-order-form">
    	<LifeForm :value.sync="servicePriceForm" :list.sync="serviceFormList" />
    </div>

    <!-- 充值表单 -->
   <!-- <div class="place-order-form">
      <LifeForm v-model="form" :list="formList" />
    </div> -->

    <!-- 充值额度选择 -->
   <!-- <div v-if="isLife === 2" class="place-order-etc">
      <div class="etc-select-title">选择充值额度</div>
      <lifeAmount v-model="price" :list="amountList"
      height="39px" />
    </div> -->

    <!-- 代金券优惠码 -->
    <!-- <div v-if="isLife === 2" class="coupon-code flex_column">
    	<div class="life-form-item flex_justry_center">
    		<div class="form-item-value code-input flex_1">
    			<input v-model="couponCode" placeholder="请输入代金券优惠码" placeholder-class="pdr9"
    			type="text" />
    		</div>
    		<div class="form-item-title code-btn" @click="checkCode">校验优惠码</div>
    	</div>
    	<div v-show="isCheck">
    		<div class="life-form-item flex_justry_center">
    			<div class="form-item-title">优惠金额</div>
    			<div class="form-item-value flex_1">
    				<span>P{{discountAmount}}</span>
    			</div>
    		</div>
    		<div class="life-form-item flex_justry_center">
    			<div class="form-item-title">应付金额</div>
    			<div class="form-item-value flex_1">
    				<span>P{{payableAmount}}</span>
    			</div>
    		</div>
    	</div>
    </div> -->

    <!-- 充值须知 -->
    <div class="place-order-notice">
      <lifeNotice />
    </div>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible"
    width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff"
        :dotScale="1" :logoSrc="downloadData.icon" :logoScale="0.2" :size="200" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 充值提交 -->
    <lifeSubmit :loading="isOrder" :title="isOrder ? loadTitle: '确认支付'" @submit="submitOrder" />
  </div>
</template>

<script>
  import LifeTopbar from '@/components/life-topBar.vue'
  import LifeForm from '@/components/life-form.vue'
  import lifeSelect from '@/config/lifeSelect.js'
  import lifeAmount from '@/components/life-amount.vue'
  import lifeNotice from '@/components/life-notice.vue'
  import lifeSubmit from '@/components/life-submit.vue'
  import vueQr from 'vue-qr'
  import cal from '@/util/calculation.js'

  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      setTimeout(() => {
        clearInterval(timer)
      }, 1000 * 60 * 5)
      if (timer) clearInterval(timer)
      timer = setInterval(callback, ms)
    }
  })()

  export default {
    components: {
      LifeTopbar,
      LifeForm,
      lifeAmount,
      lifeNotice,
      lifeSubmit,
      vueQr
    },
    data() {
      return {
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
        unit: {
        	id: '' //当前单位id(通过它得到套餐选择列表，只有单项默认选中)
        },
        unitList: [{ //缴费单位选择列表
        	key: 'id',
        	title: '缴费单位',
        	value: '',
        	tips: '请选择缴费单位',
        	type: 'select',
          name: '',
        	list: []
        }],
        packageSelect: [], //套餐选择列表
        packageAct: { //选中的套餐
        	service_fee: 0
        },
        priceForm: {}, //缴费金额表单值
        priceFormList: [{ //缴费金额表单列表
        	type: 'input',
        	isNumber: true,
        	title: '缴费金额（披索₱）',
        	key: 'price',
        	value: '',
        	tips: '在此输入账单金额',
        	disabled: false
        }],
        servicePriceForm: {}, //手续费表单值
        serviceFormList: [{
        	type: 'text',
        	title: '手续费（披索₱）',
        	key: 'service_price',
        	value: '',
        	name: ''
        }],
        // 通过选择套餐得到的表单值
        paramsForm: {},
        title: '',
        formList: [],
        form: {},

        amountList: [],
        amountLoad: [],
        price: '', //充值金额
        isOrder: false,
        // idPlactype: true,
        // accountKey: 'Account',
        // idfKey: 'Identifier',
        // couponCode: '', //优惠码
        // discountAmount: 0, //优惠金额
        // payableAmount: 0, //应付金额
        // sxfAmount: 50, //手续费
        // isCheck: false, //校验通过显示金额
        codetoken: '',
        loadTitle: '支付请求中'
      }
    },
    computed: {
      isLife() {
        return this.$store.state.isLife
      },
      orderTips() {
      	return this.$store.state.orderTips
      },
      menuList() {
      	return this.$store.state.rechargeCategory
      }
    },
    watch: {
      // 缴费单位变化
      'unit.id': {
      	handler(newVal) {
      		// console.log('unitId:', newVal)
      		if (!newVal) return
      		// 重置套餐
      		this.packageAct = {}
      		// 通过单位id得到对应的套餐列表
      		const { list } = this.unitList[0]
      		const { products } = list.find(item => item.id === newVal)
      		// 得到需要显示的套餐列表(单项默认选中不显示选择列表)
      		this.packageSelect = products
      		console.log('packageSelect:', products)
      		// if (products.length > 1) return
      		this.packageAct = products[0]
      	},
      	deep: true
      },
      // 选择套餐变化
      packageAct: {
      	handler(newVal) {
      		console.log('packageAct:', newVal)
      		if (!newVal) return
      		this.$set(this.priceFormList[0], 'value', '')
      		// amount=0价格文本框才能输入
      		if (Number(newVal.amount) === 0 && Number(newVal.doller) === 0) {
      			this.$set(this.priceFormList[0], 'disabled', false)
      		} else {
      			this.$set(this.priceFormList[0], 'disabled', true)
      		}

      		// 根据不同ptype值处理param得到账号表单
      		switch(Number(newVal.ptype)) {
      			case 1: //水电网高速
      				// this.$set(this.priceFormList[0], 'disabled', false)
      				this.analysisPtype1(newVal.param)
      				break;
      			case 5: //esim
      				this.analysisPtype5(newVal.param)
      				// 得到显示的缴费金额(披索)
      				// 1. amount大于0则显示amount
      				// 2. amount等于0则显示doller并且查询美元接口
      				// this.$set(this.priceFormList[0], 'disabled', true)
      				// if (Number(newVal.amount) > 0) {
      				// 	this.$set(this.priceFormList[0], 'value', newVal.amount)
      				// 	return
      				// }
      				// // 查询美元接口
      				// this.getQueryAmount(newVal.sku)
      				break;
      		}

      		if (Number(newVal.amount) > 0) {
      			this.$set(this.priceFormList[0], 'value', newVal.amount)
      			return
      		}
      		// 查询美元接口
      		if (newVal.doller && Number(newVal.doller) > 0) {
      			this.getQueryAmount(newVal.sku)
      		}
      	},
      	deep: true
      },
      // 缴费金额变化
      'priceForm.price': {
      	handler(newVal) {
      		// console.log(newVal)
          if (this.packageAct.ptype && this.packageAct.ptype == 5) return
      		const priceVal = newVal ? Number(newVal): 0
      		let serviceCharge = 0
      		if (priceVal > 3000) serviceCharge = Math.floor(priceVal * 2 * 0.01);
      		else serviceCharge = 50
      		const filterIndex = this.serviceFormList.findIndex(item => item.key === 'service_price')
      		if (filterIndex || filterIndex === 0) {
      			this.$set(this.serviceFormList[filterIndex], 'value', serviceCharge)
      			this.$set(this.serviceFormList[filterIndex], 'name', `₱${serviceCharge}`)
      		}
      	},
      	deep: true,
      	immediate: true
      },
      // price(newVal) { //其它缴费金额变化(Crab等)
      // 	// 金额变化修改手续费
      // 	if (!newVal) return
      // 	const { fee } = this.amountLoad.find(item => item.amount === newVal)
      // 	const feeIndex = this.formList.findIndex(item => item.key === 'service_price')
      // 	if (feeIndex === -1) return
      // 	const copyItem = JSON.parse(JSON.stringify(this.formList[feeIndex]))
      // 	copyItem.value = fee
      // 	copyItem.name = `P${fee}`
      //   this.sxfAmount = fee
      // 	this.$set(this.formList, feeIndex, copyItem)
      //   // 金额变化，重置金额
      //   this.payableAmount = 0
      //   this.discountAmount = 0
      //   this.couponCode = ''
      //   this.codetoken = ''
      //   this.isCheck = false
      // },
      // 'form.accountNumber': {
      // 	handler(newVal) {
      // 		if (!newVal) return
      // 		const numIndex = this.formList.findIndex(item => item.key === 'accountNumber')
      // 		if (newVal.length === 1) {
      // 			switch(newVal) {
      // 				case '0':
      // 					return
      // 					break;
      // 				case '9':
      // 					const unNumber = `0${newVal}`
      // 					this.setFormData(numIndex, 'value', unNumber)
      // 					return
      // 					break;
      // 				default:
      // 					this.setFormData(numIndex, 'value', '')
      // 			}
      // 		} else {
      // 			if (newVal.slice(0, 2) === '09') return
      // 			else this.setFormData(numIndex, 'value', '')
      // 		}
      // 	},
      // 	deep: true
      // }
    },
    created() {
      this.init()
    },
    methods: {
      // 查询披索价格
      getQueryAmount(product_id) {
      	// uni.showLoading({
      	// 	title: '缴费金额查询中...'
      	// });
      	this.loadTitle = '查询缴费金额中'
      	this.isOrder = true

        this.$api.request('Order/queryAmount', {
            product_id
        }).then(res => {
            this.$set(this.priceFormList[0], 'value', res.data)
            this.isOrder = false
        }).catch(error => {
            this.formMsg(error)
            this.isOrder = false
        })
      },
      // 处理ptype=5的param
      analysisPtype5(param) {
      	if (!param) return this.formList = []
      	// 得到ptype5表单列表
      	const newParam = JSON.parse(param)
      	// console.log(newParam)
      	const keys = Object.keys(newParam)
      	const values = Object.values(newParam)
      	const list = []
      	keys.forEach((item, index) => {
      		if (values[index]) {
      			const findList = values[index][0]
      			findList.forEach(ite => {
      				list.push({
      					key: ite, //当前键名
      					title: toTitleCase(ite), //标题
      					value: '', //当前输入值
      					firsKey: item, //上级键名(所属键名)
      					type: 'input', //当前类型
      					tips: '请输入' //提示文字
      				})
      			})
      		}
      	})
      	this.formList = list
      },
      // 处理ptype=1的param
      analysisPtype1(param) {
      	if (!param) return this.formList = []
      	const newParam = JSON.parse(param)
      	const list = []
      	newParam.forEach(item => {
      		list.push({
      			key: item.paramName,
      			title: item.paramName,
      			value: '',
      			type: 'input',
      			tips: item.note
      		})
      	})
      	this.formList = list
      },
      // 套餐选择
      tap(item) {
      	this.packageAct = item
      },
      // 套餐表单变化
      listChange(list) {
      	const newParams = this.paramsForm
      	list.forEach(item => {
      		// 存在上级key
      		if (item.firsKey) {
      			if (!newParams[item.firsKey]) {
      				newParams[item.firsKey] = {}
      			}
      			newParams[item.firsKey][item.key] = item.value
      		} else {
      			newParams[item.key] = item.value
      		}
      		this.$set(this, 'paramsForm', newParams)
      	})
      },
      // 校验优惠码
      // async checkCode() {
      // 	if (!this.couponCode) return this.formMsg('请输入优惠码')
      // 	if (!this.price) return this.formMsg('请选择充值金额')
      // 	const res = await this.checkRequest(this.couponCode)
      // 	// console.log(res)
      // 	if (!res) return
      // 	const { codemoney, codetoken } = res.data
      // 	this.payableAmount = codemoney
      // 	const sumPrice = cal.accAdd(this.price, this.sxfAmount)
      // 	this.discountAmount = cal.accSub(sumPrice, codemoney)
      // 	this.codetoken = codetoken
      // 	this.isCheck = true
      // 	this.formMsg(res.msg)
      // },
      // 验证码校验请求
      // checkRequest(code) {
      // 	return new Promise((resolve, reject) => {
      //     const money = cal.accAdd(this.price, this.sxfAmount)
      //     this.$api.request('Order/verifyPromoCode', {
      //       type: 2, // type=1 话费 type=2 转账
      //       money,
      //       channel: this.type,
      //       code
      //     }).then(res => {
      //       resolve(res)
      //     }).catch(error => {
      //       reject(error)
      //       this.formMsg(error)
      //     })
      // 	})
      // },
      // 提交订单
      submitOrder() {
        // if (this.isLife === 1) { //生活缴费
            // if (this.isOrder) return this.formMsg('请勿重复下单')
            // // 判断是否填写相对于数据
            // this.centerDialogVisible = false;
            // if (!this.form.itemid) return this.formMsg('请输入缴费单位')
            // if (!this.form[this.accountKey] || (!this.form[this.idfKey] && this.idPlactype)) {
            //   this.formMsg('请填写正确的账单信息')
            //   return
            // }
            // if (!this.form.price) return this.formMsg('请填写缴费金额')

            // const params = {},
            // query = {};
            // for (let k in this.form) {
            // 	if (k !== this.accountKey && k !== this.idfKey) {
            // 		query[k] = this.form[k]
            // 	} else {
            // 		params[k] = this.form[k]
            // 	}
            // }

            // const paramsdata = {
            //   params: JSON.stringify(params),
            //   client: this.$client,
            //   ...query
            // }
            if (!this.unit.id) return this.formMsg('请选择缴费单位')
            if (!this.packageAct.id) return this.formMsg('请选择套餐')
            if (Object.values(this.form).some(item => !item)) {
            	this.formMsg('请补全并填写正确的账单信息')
            	return
            }
            if (!this.priceForm.price) return this.formMsg('请填写缴费金额')
            this.loadTitle = '支付请求中'
            const data = {
            	itemid: this.packageAct.id,
            	params: JSON.stringify(this.paramsForm),
            	client: this.$client,
            	...this.priceForm
            }
            if(this.$client == 'magapp') data.payment = 'magapay'
            // service_fee大于0且ptype不等于5则需提交手续费
            if (this.packageAct.service_fee > 0 && this.packageAct.ptype != 5) {
            	data.service_price = this.servicePriceForm.service_price
            }

            // console.log('----paramsdata--->', paramsdata);
            this.$confirm(this.orderTips, '特别提醒', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.isOrder = true;
              this.$api.request('Order/rechargeCreate', data)
              .then(({ data }) => {
                this.orderSuccess(data)
              })
              .catch(error => {
                this.isOrder = false
                this.formMsg(error)
              });
            }).catch(() => {})
        // }
      },
      orderSuccess(data) {
        this.isOrder = false;
        switch(this.$client) {
          case 'h5':
          console.log('data:', data)
            this.centerDialogVisible = true;
            // this.downloadData.url = data.data.content;
            this.downloadData.url = data.h5_url
            delay(() => {
              // this.checkorder(data.data.outTradeNo)
              this.checkorder(data.out_trade_no)
            }, 3000)
            break;
          case 'wxh5':
            // let params = JSON.parse(data.data.content);
            let params = JSON.parse(data.h5_url);
            this.wxpay(params);
            break;
          case 'magapp':
            this.magpay(data);
            break;
          default:
            this.formMsg('暂不支持的客户端！')
            break;
        }
      },
      formMsg(message) {
        // console.log(message)
        this.isOrder = false;
        this.$message({
          message,
          type: "warning"
        })
      },
      routeOrderSuccess() {
        this.$router.push({
          path: '/orderSuccess'
        })
      },
      checkorder(sn) {
        this.$api
        .request('Order/check', {sn})
        .then(({ data }) => {
          // this.formMsg('支付成功')
          // this.$router.go(0);
          this.routeOrderSuccess()
        })
        .catch(error => {
          // console.log(error)
        })
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.routeOrderSuccess()
            // this.formMsg('支付成功')
          }, 50);
        }, () => {
          this.formMsg('支付失败')
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // this.formMsg('支付成功')
              // this.$router.go(0);
              this.routeOrderSuccess()
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      // 表单内容初始化
      async init() {
        const { id } = this.$route.query
      	this.initForm(id, this.menuList)

      	const withdrawRules = JSON.parse(localStorage.getItem('withdrawRules'))
      	if (withdrawRules && withdrawRules.length > 0) {
      	  this.amountLoad = withdrawRules
      	  this.amountList = withdrawRules.map(item => item.amount)
      	}
      },
      // 获取对应表单列表
      initForm(id, list) {
      	// 初始化单位及套餐
      	let unitArray = []
      	// console.log('list:', list)
      	// console.log('id:', id)
      	const { name, child_category } = list.find(item => item.id == id)
      	this.title = name
      	if (child_category) {
      		const newUnit = JSON.parse(JSON.stringify(child_category))
      		newUnit.forEach(item => {
      			item.text = item.name
      			item.value = item.id
      		})
      		unitArray = newUnit
      	}
      	this.$set(this.unitList[0], 'list', unitArray)
      	// 缴费金额只要一项则默认选中
      	if (unitArray.length === 1) {
      		this.$set(this.unit, 'id', unitArray[0].id)
      	}
      	// 初始化其它表单信息
      	// const initList = lifeSelect[type]
      	// this.formList = JSON.parse(JSON.stringify(initList))
      },
      setFormData(i, k, v) {
        this.$set(this.formList[i], k, v)
      }
    }
  }
</script>

<style lang="less" scoped>
  .place-order {
    padding-top: 146px;
    padding-bottom: 80px;

    .coupon-code {
    	padding: 0 16px;
    	margin-top: 30px;

    	.life-form-item {
    		height: 56px;
    		background: #F8F8FA;
    		border: 1px solid #E2E3E4;
    		border-radius: 16px;
    		padding: 0 18px 0 6px;
    		margin-bottom: 7.5px;

    		&:last-child {
    			margin-bottom: 0 !important;
    		}

    		.form-item-title {
    			font-family: Poppins;
    			font-size: 16px;
    			color: #686777;
    			font-weight: 500;
    			line-height: 40px;
    		}

    		.code-btn {
    			color: #ED3A42 !important;
    		}

    		.code-input {
    			input {
    				padding-left: 0 !important;
    			}
    		}

    		.form-item-value {
    			justify-content: flex-end;
    			min-width: 0;

    			.form-item-select {
    				width: 100%;
    			}

    			input {
    			  width: 100%;
    			  font-size: 16px;
    			  color: #686777;
    			  height: 24px;
    			  font-weight: 500;
    			  text-align: left;
    			  padding-left: 10px !important;
            background: none;
            outline: none;
            border: none;
    			}

    			span {
    			  font-size: 16px;
    			  color: #ED3A42;
    			  display: block;
    			}
    		}
    	}
    }

    .unit {
    	margin-top: 38px;
    	.sub {
    		display: flex;
    		flex-wrap: wrap;
    		margin-top: 16px;
    		padding: 0 16px;
    		.item {
    			width: calc((100% - 15px) / 2);
    			margin-right: 15px;
    			height: 55px;
    			background: #fff;
    			border-radius: 5px;
    			border: 1px solid #F66448;
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			flex-direction: column;
    			margin-top: 15px;
    			padding: 0 5px;
    			&:nth-child(2n) {
    				margin-right: 0;
    			}
    			&:nth-child(-n+2) {
    				margin-top: 0;
    			}
    			.price {
    				font-size: 15px;
    				color: #F66448;
    				transition: .5s;
    				font-weight: bold;
    				line-height: 16px;
    			}
    			.name {
    				font-size: 11px;
    				color: #F66448;
    				line-height: 12px;
    				transition: .5s;
    				margin-top: 5px;
            font-weight: bold;
    				text {
    					font-size: 17px;
    					font-family: Arial;
    					font-weight: bold;
    				}
    			}
    		}
    		.active {
    			background: #FFDAD3;
    			transition: all .4s;
    		}
    	}
    }
    .place-order-form {
    	margin-top: 15px;
    }

    // .place-order-form {
    //   margin-top: 38px;
    // }

    .place-order-etc {
      // padding: 0 38px;
      padding: 0 16px;
      margin-top: 23px;

      .etc-select-title {
        font-family: Poppins;
        font-size: 18px;
        color: #686777;
        font-weight: 600;
        line-height: 27px;
        margin-bottom: 16px;
        text-align: center;
      }
    }

    .place-order-notice {
      // margin-top: 71px;
      margin-top: 35px;
      padding: 0 11px 0 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/placeOrder.vue